export enum MetaRoleValue {
  ROLE_ADMIN = "10126826-be3e-4aa9-bd43-de5051751493",
  ROLE_CUSTOMER = "c833bbe9-2d1d-42b8-a4bc-1693fc62064b",
  ROLE_STORE = "56218d76-de2e-46e2-ac80-77f0e40dc26d",
  ROLE_FACTORY = "4b87db43-a1ea-4407-8e2a-c039c58912ad",
  ROLE_SERVICE = "1ca91f7e-4c71-4d4c-8b47-28c487859f99",
}
